<template>
  <div
    class="sc-message--list"
    :style="colors[messageList.direction || 'received']"
  >
    <div
      v-for="(message, idx) in messageList.data.elements"
      :key="idx"
      class="sc-message--list-element"
      :style="{ borderColor: colors.messageList.bg }"
    >
      <div
        class="sc-message--list-element-content large"
        v-if="idx == 0 && messageList.data.top_element_style == 'large'"
      >
        <div
          v-show="'image_url' in message"
          :style="{
            backgroundImage:
              'image_url' in message ? `url('${message.image_url}')` : 'none',
          }"
          class="sc-message--list-element-image"
        >
          <div class="sc-message--list-element-description">
            <h3 class="sc-message--title">{{ message.title }}</h3>
            <p
              v-if="message.subtitle"
              v-html="processContent(message.subtitle)"
            ></p>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
      <div
        class="sc-message--list-element-content compact"
        v-if="idx > 0 || messageList.data.top_element_style == 'compact'"
      >
        <div
          v-show="'image_url' in message"
          :style="{
            backgroundImage:
              'image_url' in message ? `url('${message.image_url}')` : 'none',
          }"
          class="sc-message--list-element-image"
        />
        <div class="sc-message--list-element-description">
          <h3 class="sc-message--title">{{ message.title }}</h3>
          <p
            v-if="message.subtitle"
            v-html="processContent(message.subtitle)"
          ></p>
        </div>
      </div>
      <buttons-message
        v-if="message.buttons"
        :message="{ data: { buttons: message.buttons } }"
      />
    </div>
    <div
      v-if="messageList.data.buttons.length > 0"
      class="sc-message--list-element-bottom"
    >
      <buttons-message :message="messageList" />
    </div>
  </div>
</template>

<script>
import ButtonsMessage from './ButtonsMessage.vue';
export default {
  name: 'ListMessage',
  inject: {
    colors: {
      type: Object,
    },
  },
  components: {
    ButtonsMessage,
  },
  props: {
    messageList: {
      type: Object,
      required: true,
      default() {
        return {
          data: {
            elements: [],
            buttons: [],
          },
        };
      },
    },
  },
  methods: {
    processContent(string) {
      let result = this.truncate(string, 50);
      result = this.linebreak(string);
      return result;
    },
    truncate(string, length = 100) {
      return string.length > length ? string.substr(0, length) + '...' : string;
    },
    linebreak(string) {
      return string.replace(/\n/g, '<br />');
    },
  },
};
</script>

<style lang="scss" scoped>
.sc-message--list {
  border-radius: 10px;
  max-width: 80%;
}

.sc-message--list-element {
  position: relative;
  border-bottom: 1px solid;
}
.sc-message--list-element-content {
  width: 100%;
  display: block;
  overflow: auto;
}

.sc-message--list-element-content.large {
  width: 100%;
  display: block;
  overflow: auto;
  margin: 0;
}
.sc-message--list-element-content.compact {
  padding: 0.5rem 0;
}

.sc-message--list-element-description {
  height: 100%;
  float: left;
  width: 100%;
}
.sc-message--list-element-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  width: 100%;
  height: 64px;
}

.large .sc-message--list-element-image {
  background-size: cover;
  height: auto;
  border-radius: 10px 10px 0 0;
}

.large .sc-message--list-element-description {
  color: #fff;
  border-radius: 10px 10px 0 0;
  background: rgba(0, 0, 0, 0.5);
}

.sc-message--title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
  white-space: pre-line;
}
.sc-message--list-element-description .sc-message--title,
.sc-message--list-element-description p {
  padding: 0.5rem;
}
</style>
